import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import IconThumbUp from '@/assets/icons/heroIcons/Thumb-up.svg';
import { mergeClasses } from '@/utils/style';
export function Hint(t0) {
  const $ = _c(15);
  const {
    className,
    text,
    title
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== className) {
    t2 = mergeClasses("mt-6 rounded-2xl bg-blue-700 px-5 py-4 lg:mt-8 lg:py-5", className);
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconThumbUp className="h-5 w-5" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t || $[5] !== title) {
    t4 = title || t("core:hint");
    $[4] = t;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <div className="mb-2 flex items-center gap-2 text-white">{t3}<strong className="text-base font-semibold text-white lg:text-xl">{t4}</strong></div>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== text) {
    t6 = <div className="text-sm whitespace-normal text-white lg:text-base [&>a]:text-white hover:[&>a]:text-white">{text}</div>;
    $[9] = text;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t5 || $[13] !== t6) {
    t7 = <div className={t2}>{t5}{t6}</div>;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}